import React from "react";

import ViewAppBar from "../views/ViewAppBar";
import ViewCadastroSucesso from "../views/ViewCadastroSucesso";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";




const CadastroSucesso: React.FC = () => (
  <>
    <ContatoZap />
    <div>
      <ViewAppBar />

     <ViewCadastroSucesso />
      

      <ViewFooter />
    </div>
  </>
);
export default CadastroSucesso;
